import React from 'react';
import {TouchableOpacity} from 'react-native';
import Div from '../../../../lib/Div';
import {Promo} from '../../../../../generated/smg_service_pb';
import {colors} from '../../../../assets/styles/colors';
import {convertCentsToDollars} from '../../../../utils';
import moment from 'moment';
import {useNavigation} from '@react-navigation/native';
import P from "../../../../lib/P";
import MainStyle from "../../../../../MainStyle";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import {isFullSwing} from "../../../../constants";

type PromoItemProps = { data: Promo };

const PromoCard = (props: PromoItemProps) => {
  const {data} = props;
  const navigation: NativeStackNavigationProp<any> = useNavigation();

  const calculateBonusMultiplier = (amount: number, turnoverAmount: number) => {
    const multiplier = Math.floor(turnoverAmount / amount);
    return `${multiplier}X`;
  };

  const getStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case 'LIVE':
        return `#1CE783`;
      case 'UNUSED':
        return '#007BC1';
      case 'USED':
        return `#FABF41`;
      case 'EXPIRED':
        return `#FF6262`;
      default:
        return colors.white;
    }
  };

  const getBorderColor = (status: string) => {
    switch (status.toUpperCase()) {
      case 'LIVE':
        return colors.newGreenText;
      case 'UNUSED':
        return '#007BC1';
      default:
        return colors.darkText;
    }
  };

  const onSelectItem = () => {
    if (isFullSwing) return;

    if (data.name.toLowerCase() === 'registration bonus') {
      return navigation.navigate('Promotions', {scrollTo: 'ELIGIBILITY_SECTION'});
    }

    navigation.navigate('Promotions', {scrollTo: 'PROMOTIONS_AND_PROMOTION_PERIOD'});
  };

  return (
    <TouchableOpacity onPress={onSelectItem} style={[MainStyle.full_w, MainStyle.max_w_387, MainStyle.m_b_10]}>
      <Div rounded={isFullSwing ? 2 : 20} borderWidth={1} bg={isFullSwing ? '#252526' : colors.loading_login} pt={13}
           pb={18} borderColor={isFullSwing ? '#4C4C4C' : getBorderColor(data.status || '')}>
        <P ta="center" fw="500" fs={22} mb={14}>{data?.name || ''}</P>

        <Div w={348} row mx="auto">
          <P fw="500" fs={14} flex={1} ta="center">AMOUNT</P>
          <P fw="500" fs={14} flex={1} ta="center">TURNOVER</P>
          <P fw="500" fs={14} flex={1} ta="center">STATUS</P>
        </Div>

        <Div w={348} h={isFullSwing ? undefined : 60} rounded={20} borderWidth={isFullSwing ? undefined : 1}
             borderColor={colors.settings_border} bg={isFullSwing ? undefined : colors.settings_bg} row
             alignItems="center" mb={10} mx="auto">
          <P flex={1} ta="center" fw="500" fs={24}>${convertCentsToDollars(Number(data.amount)) || ''}</P>

          <P w={100} borderHorizontalWidth={1} borderColor={colors.settings_border} ta="center" fw="500" fs={24}>
            {calculateBonusMultiplier(Number(data.amount), Number(data.turnoverAmount))}
          </P>

          <P flex={1} ta="center" fw="700" fs={16} color={getStatusColor(data.status || '')}>{data.status || ''}</P>
        </Div>

        <Div px={20} row>
          <Div row alignItems="center" flex={1} justifyContent="center">
            <P fw="500" fs={14} mr={12}>TYPE</P>
            <P fw="700" tt="uppercase" numberOfLines={1}>{data.type || ''}</P>
          </Div>

          <Div row alignItems="center" flex={1} justifyContent="center">
            <P fw="500" fs={14} mr={12}>EXP</P>
            <P fw="700" tt="uppercase">{moment.unix(Number(data.expirationDate)).format('ll')}</P>
          </Div>
        </Div>
      </Div>
    </TouchableOpacity>
  );
};

export default React.memo(PromoCard);
